import React, { FC } from 'react';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import { CourseListingSectionHeader } from 'src/public/components/course-listing/CourseListingSectionHeader';
import { Loader } from 'src/common/components/ListingItems';
import LoadingIcon from 'src/assets/icons/LoadingIcon';
import { CourseListingResult } from 'src/public/components/course-listing/CourseListingResult';
import { initialItemsCountToDisplay } from 'src/public/components/course-listing/course-listing-config';
import { CourseListingShowMoreButton } from 'src/public/components/course-listing/CourseListingAllCoursesList/CourseListingShowMoreButton';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';

export interface CourseListingSectionDisplayProps {
  sectionTitle: string;
  sectionDescription?: string;
  courseType: CourseViewType.Elearning | CourseViewType.Online | CourseViewType.CourseBundle;
  isLoading: boolean;
  noPageData: boolean;
  coursesData: CourseExcerpt[] | undefined;
  totalCourses: number;
}

export const CourseListingSectionDisplay: FC<CourseListingSectionDisplayProps> = ({
  sectionTitle,
  courseType,
  sectionDescription,
  isLoading,
  noPageData,
  coursesData,
  totalCourses,
}) => {
  return (
    <>
      <CourseListingSectionHeader title={sectionTitle} description={sectionDescription} />
      {isLoading && (
        <Loader>
          <LoadingIcon size={64} />
        </Loader>
      )}

      {!isLoading && !noPageData && <CourseListingResult data={coursesData} viewType={null} />}
      {noPageData && (
        <p style={{ textAlign: 'center' }}>Brak szkoleń spełniających wybrane kryteria</p>
      )}
      {!noPageData && totalCourses > initialItemsCountToDisplay && (
        <CourseListingShowMoreButton courseViewType={courseType} />
      )}
    </>
  );
};
